import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { NewdanhmucphieuxuatAction } from 'src/actions/newdanhmucphieuxuat.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getNewdanhmucphieuxuatStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import { isGrantPermission } from 'src/utils/utils';

import ExcelJS from 'exceljs';

import { saveAs } from 'file-saver';

import { Settings, Download, Upload, Cached } from '@material-ui/icons';

const NewdanhmucphieuxuatLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedNewdanhmucphieuxuatIds, setSelectedNewdanhmucphieuxuatIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.newdanhmucphieuxuat);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(NewdanhmucphieuxuatAction.updateFilter(payload));
    dispatch(NewdanhmucphieuxuatAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedNewdanhmucphieuxuatIds;

    if (event.target.checked) {
      newSelectedNewdanhmucphieuxuatIds = items.map((newdanhmucphieuxuat) => newdanhmucphieuxuat.id);
    } else {
      newSelectedNewdanhmucphieuxuatIds = [];
    }

    setSelectedNewdanhmucphieuxuatIds(newSelectedNewdanhmucphieuxuatIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedNewdanhmucphieuxuatIds.indexOf(id);
    let newSelectedNewdanhmucphieuxuatIds = [];

    if (selectedIndex === -1) {
      newSelectedNewdanhmucphieuxuatIds = newSelectedNewdanhmucphieuxuatIds.concat(selectedNewdanhmucphieuxuatIds, id);
    } else if (selectedIndex === 0) {
      newSelectedNewdanhmucphieuxuatIds = newSelectedNewdanhmucphieuxuatIds.concat(selectedNewdanhmucphieuxuatIds.slice(1));
    } else if (selectedIndex === selectedNewdanhmucphieuxuatIds.length - 1) {
      newSelectedNewdanhmucphieuxuatIds = newSelectedNewdanhmucphieuxuatIds.concat(selectedNewdanhmucphieuxuatIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedNewdanhmucphieuxuatIds = newSelectedNewdanhmucphieuxuatIds.concat(
        selectedNewdanhmucphieuxuatIds.slice(0, selectedIndex),
        selectedNewdanhmucphieuxuatIds.slice(selectedIndex + 1)
      );
    }

    setSelectedNewdanhmucphieuxuatIds(newSelectedNewdanhmucphieuxuatIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, newdanhmucphieuxuat) => {
    setSelected(newdanhmucphieuxuat);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(NewdanhmucphieuxuatAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(NewdanhmucphieuxuatAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  const exportExcelOne = async(record) => {
    record = await dispatch(NewdanhmucphieuxuatAction.findOne(record.id));

    if (record && record.data) {
      console.log(record.data);
      exportExcel(record.data);
    }
  }

  const exportExcel = async(record) => {
    try {
      // 1) tải template (đặt template.xlsx vào public/)
      const res = await fetch('/static/template_phieu_xuat_kho_1_1.xlsx');
      if (!res.ok) throw new Error(`Không tìm thấy template - trạng thái lỗi ${res.status}`);
      const arrayBuffer = await res.arrayBuffer();
  
      // 2) đọc workbook (chờ load xong)
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);
  
      // debug: in ra tên sheet để chắc chắn workbook đã có sheet
      console.log('Worksheets loaded:', workbook.worksheets.map(ws => ws.name));
      if (!workbook.worksheets || workbook.worksheets.length === 0) {
        throw new Error('Template không chứa sheet nào (workbook.worksheets.length === 0)');
      }
  
      // 3) lấy sheet an toàn: ưu tiên sheet đầu tiên
      const sheet = workbook.getWorksheet(1) || workbook.worksheets[0] || workbook.getWorksheet('Sheet1');
      if (!sheet) throw new Error('Không tìm thấy sheet trong template (tên/idx không đúng)');
  
      const sheet1 = workbook.getWorksheet(2) || workbook.worksheets[1] || workbook.getWorksheet('Sheet2');
      if (!sheet1) throw new Error('Không tìm thấy sheet trong template (tên/idx không đúng)');
  
      // 4) ghi dữ liệu (ví dụ)
      // Ghi theo address (A1, B2...) hoặc row/col
      
      if (record.no.toString().trim() !== '') {
        sheet.getCell('M5').value = record.no.toString().trim();
        sheet.getCell('M5').style = {
          ...sheet.getCell('M5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.co.toString().trim() !== '') {
        sheet.getCell('M6').value = record.co.toString().trim();
        sheet.getCell('M6').style = {
          ...sheet.getCell('M6').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.so.toString().trim() !== '') {
        sheet.getCell('H6').value = record.so.toString().trim();
        sheet.getCell('H6').style = {
          ...sheet.getCell('H6').style,
          font: { color: { argb: 'FFFF0000' }, name: 'Times New Roman', size: 9 }, // đỏ
        };
      }
      
      if (record.ngay.toString().trim() !== '') {
        sheet.getCell('F5').value = record.ngay.toString().trim();
        sheet.getCell('F5').style = {
          ...sheet.getCell('F5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.thang.toString().trim() !== '') {
        sheet.getCell('H5').value = record.thang.toString().trim();
        sheet.getCell('H5').style = {
          ...sheet.getCell('H5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.nam.toString().trim() !== '') {
        sheet.getCell('J5').value = record.nam.toString().trim();
        sheet.getCell('J5').style = {
          ...sheet.getCell('J5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.ho_va_ten_nguoi_nhan.toString().trim() !== '') {
        sheet.getCell('E8').value = record.ho_va_ten_nguoi_nhan.toString().trim();
        sheet.getCell('E8').style = {
          ...sheet.getCell('E8').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.khachhang_sdt.toString().trim() !== '') {
        sheet.getCell('M8').value = record.khachhang_sdt.toString().trim();
        sheet.getCell('M8').style = {
          ...sheet.getCell('M8').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.dia_chi_nguoi_nhan.toString().trim() !== '') {
        sheet.getCell('D9').value = record.dia_chi_nguoi_nhan.toString().trim();
        sheet.getCell('D9').style = {
          ...sheet.getCell('D9').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.ly_do_xuat_kho.toString().trim() !== '') {
        sheet.getCell('D10').value = record.ly_do_xuat_kho.toString().trim();
        sheet.getCell('D10').style = {
          ...sheet.getCell('D10').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.khohang_ma.toString().trim() !== '' && record.khohang_ten.toString().trim() !== '') {
        sheet.getCell('D11').value = record.khohang_ma.toString().trim() + ' - ' + record.khohang_ten.toString().trim();
        sheet.getCell('D11').style = {
          ...sheet.getCell('D11').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.khohang_dia_chi.toString().trim() !== '') {
        sheet.getCell('I11').value = record.khohang_dia_chi.toString().trim();
        sheet.getCell('I11').style = {
          ...sheet.getCell('I11').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.newdanhmucphieuxuatchitiets && record.newdanhmucphieuxuatchitiets.length > 0) {
        let newdanhmucphieuxuatchitiets = [...record.newdanhmucphieuxuatchitiets].sort((a, b) => a.index - b.index);
        let startTableRow = 16;
        let lastTabelRow = newdanhmucphieuxuatchitiets.length + startTableRow;
        let _tongSoLuongChungTu = 0;
        let _tongSoLuongThucNhap = 0;
        let _tongDonGia = 0;
        let _tongThanhTien = 0;

        for (let i = 0; i < newdanhmucphieuxuatchitiets.length; i++) {
          let chitiet = newdanhmucphieuxuatchitiets[i];
          let so_luong_chung_tu = Number(chitiet.so_luong_chung_tu.trim());
          let so_luong_thuc_nhap = Number(chitiet.so_luong_thuc_nhap.trim());
          let don_gia = 0;

          if (chitiet?.item_type?.trim() == 'chiphiphatsinh') {
            lastTabelRow--;
            continue;
          }

          // if (chitiet.price_key && typeof chitiet['sanpham_' + chitiet.price_key] !== 'undefined' && chitiet['sanpham_' + chitiet.price_key]) {
          //   don_gia = Number(chitiet['sanpham_' + chitiet.price_key]);
          // }

          don_gia = Number(chitiet?.gia_custom?.trim());

          let thanh_tien = don_gia * so_luong_thuc_nhap;

          _tongSoLuongChungTu += so_luong_chung_tu;
          _tongSoLuongThucNhap += so_luong_thuc_nhap;
          _tongDonGia += don_gia;
          _tongThanhTien += thanh_tien;

          sheet.getRow(i + startTableRow).height = 50;
          sheet.mergeCells('B' + (i + startTableRow) + ':F' + (i + startTableRow));
          sheet.mergeCells('I' + (i + startTableRow) + ':J' + (i + startTableRow));
          sheet.mergeCells('K' + (i + startTableRow) + ':L' + (i + startTableRow));

          sheet.getCell('A' + (i + startTableRow)).value = i + 1;
          sheet.getCell('A' + (i + startTableRow)).style = { 
            ...sheet.getCell('A' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };
          
          sheet.getCell('B' + (i + startTableRow)).value = chitiet?.sanpham_ten?.trim();
          sheet.getCell('B' + (i + startTableRow)).style = { 
            ...sheet.getCell('B' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('G' + (i + startTableRow)).value = chitiet?.sanpham_ma?.trim();
          sheet.getCell('G' + (i + startTableRow)).style = { 
            ...sheet.getCell('G' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };
          
          sheet.getCell('H' + (i + startTableRow)).value = chitiet?.don_vi_tinh?.trim();
          sheet.getCell('H' + (i + startTableRow)).style = { 
            ...sheet.getCell('H' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('I' + (i + startTableRow)).value = numeral(so_luong_thuc_nhap).format('0,0[.]0');
          sheet.getCell('I' + (i + startTableRow)).style = { 
            ...sheet.getCell('I' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('K' + (i + startTableRow)).value = numeral(don_gia).format('0,0[.]0');
          sheet.getCell('K' + (i + startTableRow)).style = { 
            ...sheet.getCell('K' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('M' + (i + startTableRow)).value = numeral(thanh_tien).format('0,0[.]0');
          sheet.getCell('M' + (i + startTableRow)).style = { 
            ...sheet.getCell('M' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet.getCell('N' + (i + startTableRow)).value = chitiet?.ghi_chu?.trim();
          sheet.getCell('N' + (i + startTableRow)).style = { 
            ...sheet.getCell('N' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };
        }

        sheet.getRow(lastTabelRow).height = 20;
        sheet.mergeCells('A' + (lastTabelRow) + ':H' + (lastTabelRow));
        sheet.mergeCells('I' + (lastTabelRow) + ':J' + (lastTabelRow));
        sheet.mergeCells('K' + (lastTabelRow) + ':L' + (lastTabelRow));

        sheet.getCell('A' + (lastTabelRow)).value = "Cộng";
        sheet.getCell('A' + (lastTabelRow)).style = { 
          ...sheet.getCell('A' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('I' + (lastTabelRow)).value = _tongSoLuongThucNhap == 0 ? 'x' : numeral(_tongSoLuongThucNhap).format('0,0[.]0');
        sheet.getCell('I' + (lastTabelRow)).style = { 
          ...sheet.getCell('I' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('K' + (lastTabelRow)).value = _tongDonGia == 0 ? 'x' : numeral(_tongDonGia).format('0,0[.]0');
        sheet.getCell('K' + (lastTabelRow)).style = { 
          ...sheet.getCell('K' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };
        
        sheet.getCell('M' + (lastTabelRow)).value = _tongThanhTien == 0 ? 'x' : numeral(_tongThanhTien).format('0,0[.]0');
        sheet.getCell('M' + (lastTabelRow)).style = { 
          ...sheet.getCell('M' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getCell('N' + (lastTabelRow)).value = "x";
        sheet.getCell('N' + (lastTabelRow)).style = { 
          ...sheet.getCell('N' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet.getRow(lastTabelRow + 2).height = 15;
        sheet.getRow(lastTabelRow + 3).height = 15;

        sheet.mergeCells('A' + (lastTabelRow + 1) + ':P' + (lastTabelRow + 1));

        sheet.getCell('A' + (lastTabelRow + 2)).value = '- Tổng số tiền (viết bằng chữ):';
        sheet.getCell('A' + (lastTabelRow + 2)).style = { 
          ...sheet.getCell('A' + (lastTabelRow + 2)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet.getCell('E' + (lastTabelRow + 2)).value = record.tong_so_tien_viet_bang_chu + './.';
        sheet.getCell('E' + (lastTabelRow + 2)).style = { 
          ...sheet.getCell('E' + (lastTabelRow + 2)).style, 
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet.getCell('A' + (lastTabelRow + 3)).value = '- Số chứng từ gốc kèm theo:';
        sheet.getCell('A' + (lastTabelRow + 3)).style = { 
          ...sheet.getCell('A' + (lastTabelRow + 3)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet.getCell('E' + (lastTabelRow + 3)).value = record.so_chung_tu_goc_kem_theo;
        sheet.getCell('E' + (lastTabelRow + 3)).style = { 
          ...sheet.getCell('E' + (lastTabelRow + 3)).style, 
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        for (let c = 5; c <= 14; c++) {
          const cellfooter = sheet.getCell(lastTabelRow + 2, c);
          const cellfooter1 = sheet.getCell(lastTabelRow + 3, c);
          cellfooter.border = {
            bottom: { style: 'dotted', color: { argb: 'FF000000' } },
          };
          cellfooter1.border = {
            bottom: { style: 'dotted', color: { argb: 'FF000000' } },
          };
        }

        const startRow = startTableRow;
        const endRow = lastTabelRow; // vd = 19
        const startCol = 1; // A
        const endCol = 14; // N

        // 1) tạo/đặt border cho đúng vùng B14:I(endRow)
        for (let r = startRow; r <= endRow; r++) {
          for (let c = startCol; c <= endCol; c++) {
            const cell = sheet.getCell(r, c);
            // set border (tạo ô trong vùng này thôi)
            cell.border = {
              top:    { style: 'thin', color: { argb: 'FF000000' } },
              left:   { style: 'thin', color: { argb: 'FF000000' } },
              bottom: { style: 'thin', color: { argb: 'FF000000' } },
              right:  { style: 'thin', color: { argb: 'FF000000' } },
            };
          }
        }
      }

      //=========

      if (record.phieu_thu_quyen_so.toString().trim() !== '') {
        sheet1.getCell('M4').value = record.phieu_thu_quyen_so.toString().trim();
        sheet1.getCell('M4').style = {
          ...sheet1.getCell('M4').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.phieu_thu_so.toString().trim() !== '') {
        sheet1.getCell('M5').value = record.phieu_thu_so.toString().trim();
        sheet1.getCell('M5').style = {
          ...sheet1.getCell('M5').style,
          font: { color: { argb: 'FFFF0000' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.phieu_thu_no.toString().trim() !== '') {
        sheet1.getCell('M6').value = record.phieu_thu_no.toString().trim();
        sheet1.getCell('M6').style = {
          ...sheet1.getCell('M6').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.phieu_thu_co.toString().trim() !== '') {
        sheet1.getCell('M7').value = record.phieu_thu_co.toString().trim();
        sheet1.getCell('M7').style = {
          ...sheet1.getCell('M7').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.ngay.toString().trim() !== '') {
        sheet1.getCell('F5').value = record.ngay.toString().trim();
        sheet1.getCell('F5').style = {
          ...sheet1.getCell('F5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.thang.toString().trim() !== '') {
        sheet1.getCell('H5').value = record.thang.toString().trim();
        sheet1.getCell('H5').style = {
          ...sheet1.getCell('H5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.nam.toString().trim() !== '') {
        sheet1.getCell('J5').value = record.nam.toString().trim();
        sheet1.getCell('J5').style = {
          ...sheet1.getCell('J5').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }
      
      if (record.ho_va_ten_nguoi_nhan.toString().trim() !== '') {
        sheet1.getCell('E8').value = record.ho_va_ten_nguoi_nhan.toString().trim();
        sheet1.getCell('E8').style = {
          ...sheet1.getCell('E8').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.khachhang_sdt.toString().trim() !== '') {
        sheet1.getCell('M8').value = record.khachhang_sdt.toString().trim();
        sheet1.getCell('M8').style = {
          ...sheet1.getCell('M8').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.dia_chi_nguoi_nhan.toString().trim() !== '') {
        sheet1.getCell('C9').value = record.dia_chi_nguoi_nhan.toString().trim();
        sheet1.getCell('C9').style = {
          ...sheet1.getCell('C9').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.phieu_thu_noi_dung_thu.toString().trim() !== '') {
        sheet1.getCell('C10').value = record.phieu_thu_noi_dung_thu.toString().trim();
        sheet1.getCell('C10').style = {
          ...sheet1.getCell('C10').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.phieu_thu_so_tien.toString().trim() !== '') {
        sheet1.getCell('C11').value = record.phieu_thu_so_tien.toString().trim();
        sheet1.getCell('C11').style = {
          ...sheet1.getCell('C11').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.phieu_thu_so_tien_viet_bang_chu.toString().trim() !== '') {
        sheet1.getCell('D12').value = record.phieu_thu_so_tien_viet_bang_chu.toString().trim();
        sheet1.getCell('D12').style = {
          ...sheet1.getCell('D12').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.phieu_thu_kem_theo.toString().trim() !== '') {
        sheet1.getCell('C13').value = record.phieu_thu_kem_theo.toString().trim();
        sheet1.getCell('C13').style = {
          ...sheet1.getCell('C13').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.so_chung_tu_goc_kem_theo.toString().trim() !== '') {
        sheet1.getCell('C14').value = record.so_chung_tu_goc_kem_theo.toString().trim();
        sheet1.getCell('C14').style = {
          ...sheet1.getCell('C14').style,
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
        };
      }

      if (record.newdanhmucphieuxuatchitiets && record.newdanhmucphieuxuatchitiets.length > 0) {
        let newdanhmucphieuxuatchitiets = [...record.newdanhmucphieuxuatchitiets].sort((a, b) => a.index - b.index);
        let startTableRow = 19;
        let lastTabelRow = newdanhmucphieuxuatchitiets.length + startTableRow;
        let _tongSoLuongChungTu = 0;
        let _tongSoLuongThucNhap = 0;
        let _tongDonGia = 0;
        let _tongThanhTien = 0;

        for (let i = 0; i < newdanhmucphieuxuatchitiets.length; i++) {
          let chitiet = newdanhmucphieuxuatchitiets[i];
          let so_luong_chung_tu = Number(chitiet.so_luong_chung_tu.trim());
          let so_luong_thuc_nhap = Number(chitiet.so_luong_thuc_nhap.trim());
          let don_gia = 0;

          if (chitiet?.item_type?.trim() == 'sanpham') {
            // if (chitiet.price_key && typeof chitiet['sanpham_' + chitiet.price_key] !== 'undefined' && chitiet['sanpham_' + chitiet.price_key]) {
            //   don_gia = Number(chitiet['sanpham_' + chitiet.price_key]);
            // }

            don_gia = Number(chitiet?.gia_custom?.trim());
          } else if (chitiet?.item_type?.trim() == 'chiphiphatsinh') {
            don_gia = Number(chitiet?.chiphiphatsinh_gia?.trim());
          }

          let thanh_tien = don_gia * so_luong_thuc_nhap;

          _tongSoLuongChungTu += so_luong_chung_tu;
          _tongSoLuongThucNhap += so_luong_thuc_nhap;
          _tongDonGia += don_gia;
          _tongThanhTien += thanh_tien;

          sheet1.getRow(i + startTableRow).height = 50;
          sheet1.mergeCells('B' + (i + startTableRow) + ':F' + (i + startTableRow));
          sheet1.mergeCells('I' + (i + startTableRow) + ':J' + (i + startTableRow));
          sheet1.mergeCells('K' + (i + startTableRow) + ':L' + (i + startTableRow));

          sheet1.getCell('A' + (i + startTableRow)).value = i + 1;
          sheet1.getCell('A' + (i + startTableRow)).style = { 
            ...sheet1.getCell('A' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };
          
          if (chitiet?.item_type?.trim() == 'sanpham') sheet1.getCell('B' + (i + startTableRow)).value = chitiet?.sanpham_ten?.trim();
          else if (chitiet?.item_type?.trim() == 'chiphiphatsinh') sheet1.getCell('B' + (i + startTableRow)).value = chitiet?.chiphiphatsinh_ten?.trim();
          sheet1.getCell('B' + (i + startTableRow)).style = { 
            ...sheet1.getCell('B' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          if (chitiet?.item_type?.trim() == 'sanpham') sheet1.getCell('G' + (i + startTableRow)).value = chitiet?.sanpham_ma?.trim();
          else if (chitiet?.item_type?.trim() == 'chiphiphatsinh') sheet1.getCell('G' + (i + startTableRow)).value = chitiet?.chiphiphatsinh_ma?.trim();
          sheet1.getCell('G' + (i + startTableRow)).style = { 
            ...sheet1.getCell('G' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };
          
          sheet1.getCell('H' + (i + startTableRow)).value = chitiet?.don_vi_tinh?.trim();
          sheet1.getCell('H' + (i + startTableRow)).style = { 
            ...sheet1.getCell('H' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet1.getCell('I' + (i + startTableRow)).value = numeral(so_luong_thuc_nhap).format('0,0[.]0');
          sheet1.getCell('I' + (i + startTableRow)).style = { 
            ...sheet1.getCell('I' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet1.getCell('K' + (i + startTableRow)).value = numeral(don_gia).format('0,0[.]0');
          sheet1.getCell('K' + (i + startTableRow)).style = { 
            ...sheet1.getCell('K' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet1.getCell('M' + (i + startTableRow)).value = numeral(thanh_tien).format('0,0[.]0');
          sheet1.getCell('M' + (i + startTableRow)).style = { 
            ...sheet1.getCell('M' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };

          sheet1.getCell('N' + (i + startTableRow)).value = chitiet?.ghi_chu?.trim();
          sheet1.getCell('N' + (i + startTableRow)).style = { 
            ...sheet1.getCell('N' + (i + startTableRow)).style, 
            font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9 },
            alignment: { 
              wrapText: true,
              vertical: 'middle', 
              horizontal: 'center', 
            },
          };
        }

        sheet1.getRow(lastTabelRow).height = 20;
        sheet1.mergeCells('A' + (lastTabelRow) + ':H' + (lastTabelRow));
        sheet1.mergeCells('I' + (lastTabelRow) + ':J' + (lastTabelRow));
        sheet1.mergeCells('K' + (lastTabelRow) + ':L' + (lastTabelRow));

        sheet1.getCell('A' + (lastTabelRow)).value = "Cộng";
        sheet1.getCell('A' + (lastTabelRow)).style = { 
          ...sheet1.getCell('A' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet1.getCell('I' + (lastTabelRow)).value = _tongSoLuongThucNhap == 0 ? 'x' : numeral(_tongSoLuongThucNhap).format('0,0[.]0');
        sheet1.getCell('I' + (lastTabelRow)).style = { 
          ...sheet1.getCell('I' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet1.getCell('K' + (lastTabelRow)).value = _tongDonGia == 0 ? 'x' : numeral(_tongDonGia).format('0,0[.]0');
        sheet1.getCell('K' + (lastTabelRow)).style = { 
          ...sheet1.getCell('K' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };
        
        sheet1.getCell('M' + (lastTabelRow)).value = _tongThanhTien == 0 ? 'x' : numeral(_tongThanhTien).format('0,0[.]0');
        sheet1.getCell('M' + (lastTabelRow)).style = { 
          ...sheet1.getCell('M' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet1.getCell('N' + (lastTabelRow)).value = "x";
        sheet1.getCell('N' + (lastTabelRow)).style = { 
          ...sheet1.getCell('N' + (lastTabelRow)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, bold: true, },
          alignment: { 
            wrapText: true,
            vertical: 'middle', 
            horizontal: 'center', 
          },
        };

        sheet1.getRow(lastTabelRow + 2).height = 15;
        sheet1.getRow(lastTabelRow + 3).height = 15;

        sheet1.mergeCells('A' + (lastTabelRow + 1) + ':P' + (lastTabelRow + 1));

        sheet1.getCell('A' + (lastTabelRow + 2)).value = ' Đã nhận đủ số tiền (viết bằng chữ):';
        sheet1.getCell('A' + (lastTabelRow + 2)).style = { 
          ...sheet1.getCell('A' + (lastTabelRow + 2)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet1.getCell('F' + (lastTabelRow + 2)).value = record.phieu_thu_da_nhan_du_so_tien_viet_bang_chu + './.';
        sheet1.getCell('F' + (lastTabelRow + 2)).style = { 
          ...sheet1.getCell('F' + (lastTabelRow + 2)).style, 
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet1.getCell('A' + (lastTabelRow + 3)).value = '+ Tỷ giá ngoại tệ (vàng bạc, đá quý):';
        sheet1.getCell('A' + (lastTabelRow + 3)).style = { 
          ...sheet1.getCell('A' + (lastTabelRow + 3)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet1.getCell('F' + (lastTabelRow + 3)).value = record.phieu_thu_ty_gia_ngoai_te;
        sheet1.getCell('F' + (lastTabelRow + 3)).style = { 
          ...sheet1.getCell('F' + (lastTabelRow + 3)).style, 
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet1.getCell('A' + (lastTabelRow + 4)).value = '+ Số tiền quy đổi:';
        sheet1.getCell('A' + (lastTabelRow + 4)).style = { 
          ...sheet1.getCell('A' + (lastTabelRow + 4)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet1.getCell('D' + (lastTabelRow + 4)).value = record.phieu_thu_so_tien_quy_doi;
        sheet1.getCell('D' + (lastTabelRow + 4)).style = { 
          ...sheet1.getCell('D' + (lastTabelRow + 4)).style, 
          font: { color: { argb: 'FF0000FF' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        sheet1.getCell('A' + (lastTabelRow + 5)).value = '(Liên gửi ra ngoài phải đóng dấu)';
        sheet1.getCell('A' + (lastTabelRow + 5)).style = { 
          ...sheet1.getCell('A' + (lastTabelRow + 5)).style, 
          font: { color: { argb: 'FF000000' }, name: 'Times New Roman', size: 9, },
          alignment: { 
            wrapText: false,
            vertical: 'bottom', 
            horizontal: 'left', 
          },
        };

        for (let c = 6; c <= 14; c++) {
          const cellfooter = sheet1.getCell(lastTabelRow + 2, c);
          const cellfooter1 = sheet1.getCell(lastTabelRow + 3, c);
          cellfooter.border = {
            bottom: { style: 'dotted', color: { argb: 'FF000000' } },
          };
          cellfooter1.border = {
            bottom: { style: 'dotted', color: { argb: 'FF000000' } },
          };
        }

        for (let c = 4; c <= 14; c++) {
          const cellfooter = sheet1.getCell(lastTabelRow + 4, c);
          cellfooter.border = {
            bottom: { style: 'dotted', color: { argb: 'FF000000' } },
          };
        }

        const startRow = startTableRow;
        const endRow = lastTabelRow; // vd = 19
        const startCol = 1; // A
        const endCol = 14; // N

        // 1) tạo/đặt border cho đúng vùng B14:I(endRow)
        for (let r = startRow; r <= endRow; r++) {
          for (let c = startCol; c <= endCol; c++) {
            const cell = sheet1.getCell(r, c);
            // set border (tạo ô trong vùng này thôi)
            cell.border = {
              top:    { style: 'thin', color: { argb: 'FF000000' } },
              left:   { style: 'thin', color: { argb: 'FF000000' } },
              bottom: { style: 'thin', color: { argb: 'FF000000' } },
              right:  { style: 'thin', color: { argb: 'FF000000' } },
            };
          }
        }
      }

      //=========

      // let demSoLuong = 0;
      // let tongThanhTien = 0;

      // if (record.khos && record.khos.length > 0) {
      //   for (let i = 0; i < record.khos.length; i++) {
      //     let kho = record.khos[i];

      //     // const cellTenSanPham = sheet.getCell('C' + (i + 17));
      //     // cellTenSanPham.value = kho.ten_san_pham_text + '\n' + kho.phien_ban_san_pham_text + (kho.thong_tin_them.trim() != '' ? '\n' + kho.thong_tin_them.trim() : '');
      //     // cellTenSanPham.alignment = { wrapText: true };

      //     sheet.getRow(i + 17).height = 100;
      //     sheet.mergeCells('C' + (i + 17) + ':D' + (i + 17));

      //     sheet.getCell('B' + (i + 17)).value = i + 1;
      //     sheet.getCell('C' + (i + 17)).value = kho.ten_san_pham_text + '\n' + kho.phien_ban_san_pham_text + (kho.thong_tin_them.trim() != '' ? '\n' + kho.thong_tin_them.trim() : '');
      //     sheet.getCell('E' + (i + 17)).value = kho.ma_san_pham;
      //     sheet.getCell('G' + (i + 17)).value = '';

      //     let cellSoLuong = sheet.getCell('F' + (i + 17));
      //     cellSoLuong.value = Math.abs(Number(kho.nhap_xuat));
      //     cellSoLuong.numFmt = '#,##0';

      //     let cellDonGia = sheet.getCell('H' + (i + 17));
      //     cellDonGia.value = Number(kho.don_gia);
      //     cellDonGia.numFmt = '#,##0';

      //     let cellThanhTien = sheet.getCell('I' + (i + 17));
      //     cellThanhTien.value = Number(kho.don_gia) * Math.abs(Number(kho.nhap_xuat));
      //     cellThanhTien.numFmt = '#,##0';

      //     demSoLuong += Math.abs(Number(kho.nhap_xuat));
      //     tongThanhTien += Number(kho.don_gia) * Math.abs(Number(kho.nhap_xuat));
      //   }

      //   console.log('C' + (record.khos.length + 17));

      //   sheet.getCell('F' + (record.khos.length + 17)).numFmt = '#,##0'; 
      //   sheet.getCell('I' + (record.khos.length + 17)).numFmt = '#,##0'; 

      //   sheet.mergeCells('C' + (record.khos.length + 17) + ':D' + (record.khos.length + 17));

      //   const cellCong = sheet.getCell('C' + (record.khos.length + 17));
      //   cellCong.value = "Cộng";
      //   cellCong.style = { ...cellCong.style, font: { name: 'Times New Roman', size: 9, bold: true } };

      //   sheet.getCell('E' + (record.khos.length + 17)).value = 'x';
      //   sheet.getCell('F' + (record.khos.length + 17)).value = demSoLuong;
      //   sheet.getCell('G' + (record.khos.length + 17)).value = '-';
      //   sheet.getCell('H' + (record.khos.length + 17)).value = 'x';

      //   const cellTongThanhTien = sheet.getCell('I' + (record.khos.length + 17));
      //   cellTongThanhTien.value = tongThanhTien;
      //   cellTongThanhTien.style = { ...cellTongThanhTien.style, font: { name: 'Times New Roman', size: 9, bold: true } };

      //   const startRow = 14;
      //   const endRow = record.khos.length + 17; // vd = 19
      //   const startCol = 2; // B
      //   const endCol = 9;   // I

      //   // 1) tạo/đặt border cho đúng vùng B14:I(endRow)
      //   for (let r = startRow; r <= endRow; r++) {
      //     for (let c = startCol; c <= endCol; c++) {
      //       const cell = sheet.getCell(r, c);
      //       // set border (tạo ô trong vùng này thôi)
      //       cell.border = {
      //         top:    { style: 'thin', color: { argb: 'FF000000' } },
      //         left:   { style: 'thin', color: { argb: 'FF000000' } },
      //         bottom: { style: 'thin', color: { argb: 'FF000000' } },
      //         right:  { style: 'thin', color: { argb: 'FF000000' } },
      //       };
      //     }
      //   }

      //   // 2) CLEANUP: xóa các hàng TRỐNG phía dưới endRow để tránh !ref mở rộng
      //   // (Chỉ xóa row r nếu r > endRow và row không có ô nào chứa value)
      //   for (let r = sheet.rowCount; r > endRow; r--) {
      //     const row = sheet.getRow(r);
      //     let hasVal = false;
      //     row.eachCell({ includeEmpty: false }, (cell) => {
      //       if (cell.value !== null && cell.value !== undefined && cell.value !== '') {
      //         hasVal = true;
      //       }
      //     });
      //     if (!hasVal) {
      //       // remove the empty row so sheet range shrinks
      //       sheet.spliceRows(r, 1);
      //     } else {
      //       break; // gặp hàng có dữ liệu -> dừng
      //     }
      //   }

      //   sheet.mergeCells('D' + (record.khos.length + 20) + ':F' + (record.khos.length + 20));
      //   sheet.mergeCells('H' + (record.khos.length + 20) + ':I' + (record.khos.length + 20));
      //   sheet.mergeCells('H' + (record.khos.length + 28) + ':I' + (record.khos.length + 28));

      //   const cellNguoiLapPhieu = sheet.getCell('C' + (record.khos.length + 20));
      //   cellNguoiLapPhieu.value = "NGƯỜI LẬP PHIẾU";
      //   cellNguoiLapPhieu.style = {
      //     ...cellCong.style,
      //     font: { name: 'Times New Roman', size: 9, bold: true },
      //     border: { // Xóa hết border
      //       top: { style: 'none' },
      //       left: { style: 'none' },
      //       bottom: { style: 'none' },
      //       right: { style: 'none' }
      //     },
      //     alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
      //   };

      //   const cellNguoiGiaoHang = sheet.getCell('D' + (record.khos.length + 20));
      //   cellNguoiGiaoHang.value = "NGƯỜI GIAO HÀNG";
      //   cellNguoiGiaoHang.style = {
      //     ...cellCong.style,
      //     font: { name: 'Times New Roman', size: 9, bold: true },
      //     border: { // Xóa hết border
      //       top: { style: 'none' },
      //       left: { style: 'none' },
      //       bottom: { style: 'none' },
      //       right: { style: 'none' }
      //     },
      //     alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
      //   };

      //   const cellThuKho = sheet.getCell('G' + (record.khos.length + 20));
      //   cellThuKho.value = "THỦ KHO";
      //   cellThuKho.style = {
      //     ...cellCong.style,
      //     font: { name: 'Times New Roman', size: 9, bold: true },
      //     border: { // Xóa hết border
      //       top: { style: 'none' },
      //       left: { style: 'none' },
      //       bottom: { style: 'none' },
      //       right: { style: 'none' }
      //     },
      //     alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
      //   };

      //   const cellNguoiNhan = sheet.getCell('H' + (record.khos.length + 20));
      //   cellNguoiNhan.value = "NGƯỜI NHẬN";
      //   cellNguoiNhan.style = {
      //     ...cellCong.style,
      //     font: { name: 'Times New Roman', size: 9, bold: true },
      //     border: { // Xóa hết border
      //       top: { style: 'none' },
      //       left: { style: 'none' },
      //       bottom: { style: 'none' },
      //       right: { style: 'none' }
      //     },
      //     alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
      //   };

      //   const cellNguoiNhanChuKy = sheet.getCell('H' + (record.khos.length + 28));
      //   cellNguoiNhanChuKy.value = record.ho_ten_nguoi_nhan + ' - ' + record.sdt_nguoi_nhan;
      //   cellNguoiNhanChuKy.style = {
      //     ...cellCong.style,
      //     font: { name: 'Times New Roman', size: 9, bold: true },
      //     border: { // Xóa hết border
      //       top: { style: 'none' },
      //       left: { style: 'none' },
      //       bottom: { style: 'none' },
      //       right: { style: 'none' }
      //     },
      //     alignment: { vertical: 'middle', horizontal: 'center' } // Căn giữa cả dọc và ngang
      //   };
      // }

      // 5) xuất file
      const buf = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, record.so + '.xlsx');
  
      console.log('Export xong');
    } catch (err) {
      console.error('exportFromTemplate error:', err);
      alert(err.message || 'Lỗi khi xuất file');
    }
  }

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: '500px', width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Số phiếu
                </TableCell>
                <TableCell>
                  Ngày nhập liệu
                </TableCell>
                <TableCell>
                  Chức năng
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((newdanhmucphieuxuat, index) => (
                newdanhmucphieuxuat ? <TableRow
                  hover
                  key={newdanhmucphieuxuat.id}
                  selected={selectedNewdanhmucphieuxuatIds.indexOf(newdanhmucphieuxuat.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucphieuxuat.so}
                    </Typography>
                  </TableCell>
                  
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {newdanhmucphieuxuat.createdAt ? moment(newdanhmucphieuxuat.createdAt).format('YYYY-MM-DD HH:mm:ss') : ''}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <IconButton aria-label="export" onClick={() => exportExcelOne(newdanhmucphieuxuat)}>
                      <Download style={{ color: "#3498db", width: '24px', height: '24px' }} />
                    </IconButton>
                    {(role.priority < 4) && <IconButton aria-label="edit" onClick={() => onSelected(newdanhmucphieuxuat.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>}
                    {(role.priority < 4) && <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, newdanhmucphieuxuat)}>
                      <Trash2Icon color='red' />
                    </IconButton>}
                  </TableCell>
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default NewdanhmucphieuxuatLookupDetail;
